import CoinHeartbeat from "@components/utils/CoinHeartbeat";
import { Banner, WarningWrapper, cn } from "kz-ui-sdk";
import React from "react";

interface BaseBannerProps {
  banner: Banner;
  onClick?: () => void;
  claimable?: boolean;
}

const BaseBanner: React.FC<BaseBannerProps> = (props) => {
  const { banner, onClick, claimable = false } = props;
  return (
    <div
      className="relative"
      draggable={false}
    >
      <WarningWrapper
        isShown={claimable}
        classes={{
          "root&": "w-[74px] basis-[74px] shrink-0 select-none",
          "span&": "right-[-4px] top-[-2px] !h-[16px] !w-[16px] !text-[10px]",
        }}
        icon={
          <CoinHeartbeat
            className="absolute -right-[4px] -top-[4px]"
            imgClassName="h-[12px] w-[12px]"
          />
        }
      >
        <button
          onClick={onClick}
          className={cn("mt-3 flex h-[40px] w-[74px] grow items-center justify-center overflow-hidden rounded", {
            "cursor-pointer": !!onClick,
            "bg-darkBrand-900": !banner?.primaryImage?.url,
          })}
        >
          {banner?.primaryImage?.url ? (
            <img
              src={banner?.primaryImage?.url}
              alt={banner.name}
              className="h-full w-full object-cover object-center"
              draggable={false}
            />
          ) : (
            <div className="select-none px-2 text-center text-xs text-content-soft">Mini Banner</div>
          )}
        </button>
      </WarningWrapper>
    </div>
  );
};

export default BaseBanner;
